import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { PrivateRoute } from '@gsa/afp-shared-ui-utils';
import ContractSearch from './contract-search/contract-search';
import ContractHeader from './contract-header/contract-header';
import ContractLine from './contract-line';
import ContractLineVersion from './contract-line-version/';
import ContractLineTemplate from './line-template/contract-line-template';
import ContractLineHistory from './line-history/index';
import ContractHeaderHistory from './contract-header-history';
import ContractHeaderHistoryVersion from './contract-header-history-version/contract-header-history-version';
import ContractProvider from './contract-provider';

const Contract = () => {
  const location = useLocation();
  return (
    <ContractProvider>
      <Routes>
        <Route
          path="/"
          element={
            <PrivateRoute title="Contracts" contextLocation={location}>
              <ContractSearch />
            </PrivateRoute>
          }
        />

        <Route
          path="/contract-header/:contractHeaderId"
          element={
            <PrivateRoute title="Contract Header" contextLocation={location}>
              <ContractHeader />
            </PrivateRoute>
          }
        />

        <Route
          path="/contract-header/:contractHeaderId/history"
          element={
            <PrivateRoute title="Contract History" contextLocation={location}>
              <ContractHeaderHistory />
            </PrivateRoute>
          }
        />

        <Route
          path="/contract-header/:contractHeaderId/history/:versionNumber"
          element={
            <PrivateRoute
              title="Contract Header History Version"
              contextLocation={location}
            >
              <ContractHeaderHistoryVersion />
            </PrivateRoute>
          }
        />

        <Route
          path="/contract-header/:contractHeaderId/lines"
          element={
            <PrivateRoute
              title="Contract Line Listing"
              contextLocation={location}
            >
              <ContractLine />
            </PrivateRoute>
          }
        />

        <Route
          path="/contract-header/:contractHeaderId/history/:versionNumber/lines"
          element={
            <PrivateRoute
              title="Contract Version Line Listing"
              contextLocation={location}
            >
              <ContractLineVersion />
            </PrivateRoute>
          }
        />

        <Route
          path="/:contractHeaderId/contract-line-template/:contractLineId"
          element={
            <PrivateRoute
              title="Contract Line Template"
              contextLocation={location}
            >
              <ContractLineTemplate />
            </PrivateRoute>
          }
        />

        <Route
          path="/:contractHeaderId/contract-line-template/:contractLineId/history"
          element={
            <PrivateRoute
              title="Contract Line History"
              contextLocation={location}
            >
              <ContractLineHistory />
            </PrivateRoute>
          }
        />

        <Route
          path="/:contractHeaderId/contract-line-template/:contractLineId/history/:versionNumber"
          element={
            <PrivateRoute
              title="Contract Line History Version"
              contextLocation={location}
            >
              <ContractLineTemplate />
            </PrivateRoute>
          }
        />
      </Routes>
    </ContractProvider>
  );
};

export default Contract;
